import { apiService } from './api';

export interface BillingPlacement {
  placementId: string;
  orderNumber: string;
  orderDate: string;
  siteUrl: string;
  clientName: string;
  projectName: string;
  submissionType: 'GBS' | 'LI';
  clientPrice: number;
  basePrice: number;
  liveUrl: string | null;
  placedAt: string | null;
}

export interface MonthlyTotal {
  month: string;
  year: number;
  total: number;
  count: number;
}

export interface MonthlyBillingResponse {
  placements: BillingPlacement[];
  monthlyTotals: MonthlyTotal[];
  overallTotal: number;
  totalPlacements: number;
}

export interface PublisherBillingData {
  publisherId: string;
  publisherName: string;
  publisherEmail: string;
  placements: BillingPlacement[];
  monthlyTotals: MonthlyTotal[];
  totalEarnings: number;
  totalClientRevenue: number;
  totalPlacements: number;
}

export interface AdminBillingResponse {
  publishers: PublisherBillingData[];
  totalEarnings: number;
  totalPublisherCost: number;
  grandTotal: number;
  totalPlacements: number;
  publisherCount: number;
}

class PublisherBillingService {
  async getMonthlyBilling(month?: number, year?: number): Promise<{ success: boolean; data?: MonthlyBillingResponse; error?: string }> {
    const params = new URLSearchParams();
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    
    const url = `/publisher-earnings/monthly-billing${params.toString() ? `?${params.toString()}` : ''}`;
    return await apiService.get(url);
  }

  async getAdminBilling(publisherId?: string, month?: number, year?: number): Promise<{ success: boolean; data?: AdminBillingResponse; error?: string }> {
    const params = new URLSearchParams();
    if (publisherId) params.append('publisherId', publisherId);
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());
    
    const url = `/publisher-earnings/admin-billing${params.toString() ? `?${params.toString()}` : ''}`;
    return await apiService.get(url);
  }
}

export default new PublisherBillingService();
